import { IDefaultEmailTemplate } from "@evennt-tech/api-v2-core";

export const PreviewEmailTemplate = "PREVIEW_EMAIL_TEMPLATE";

/**
 * What the open editor currently holds for every non-base language, by
 * language code — saved translations plus anything typed since. Blank fields
 * are left out: the preview falls back to the source text for those, the way
 * the API does when it renders a real email.
 */
export type PreviewEmailTemplateTranslations = Record<
  string,
  Partial<Record<keyof IDefaultEmailTemplate, string>>
>;

export interface PreviewEmailTemplateBroadcastChannel {
  type: "update" | "reload" | "close-update";
  data?: IDefaultEmailTemplate | null;
  translations?: PreviewEmailTemplateTranslations;
}
